
var navbarSearch = {
    go: function () {

        // jQuery global vars
        var $window = $(window);
        var $document = $(document);
        var $body = $('#kit-body');
        var $searchField = $('.kit-navbar--flyout .kit-navbar__searchfield');
        var $searchButton = $('.kit-navbar--flyout .kit-navbar__btn-search');

        // non JQuery global vars
        //var resizeTimer;
        //var resizeDelay = 200;

        // --------------------------------------------------------------------
        // on document ready
        // --------------------------------------------------------------------

        $(function () {
            if ($searchButton.length) {
                AddSearchEvents();
            }
        });

        // --------------------------------------------------------------------
        // on window resize
        // --------------------------------------------------------------------

        /*
        $window.on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // executes after window resize has finished
                CheckSearch();
            }, resizeDelay);
        });
        */

        $document.on('viewsizeChanged', function () {
            if ($searchField.length) {
                CheckSearch();
            }
        });

        // --------------------------------------------------------------------
        // functions
        // --------------------------------------------------------------------

        function AddSearchEvents() {
            // show search field if hidden or search if visible
            $searchButton.click(function (e) {
                if ($body.hasClass('is-lg')) {
                    e.stopPropagation();
                    if (!$searchField.is(':visible')) {
                        $searchField.show();
                        e.preventDefault();
                    }
                }
            });

            // close search field when clicked elsewhere
            $window.click(function (e) {
                if ($body.hasClass('is-lg')) {
                    $searchField.hide();
                }
            });
            $searchField.click(function (e) {
                if ($body.hasClass('is-lg')) {
                    e.stopPropagation();
                }
            });

            // close search field on ESC pressed
            $document.keyup(function (e) {
                if ($body.hasClass('is-lg') && e.keyCode === 27) {
                    $searchField.hide();
                }
            });
        }

        // shows search on mobile - hides on desktop
        function CheckSearch() {
            if ($body.hasClass('is-lg')) {
                $searchField.hide();
            } else {
                $searchField.show();
            }
        }
    }
}
navbarSearch.go();
